import { AntimalwareAntiTamperingPanelController } from '../controller/AntimalwareAntiTamperingPanelController';
import { AntimalwareAntiTamperingFormValue } from '../types';
import { BaseFormFieldWebComponentElement } from '../../../framework/BaseFormFieldWebComponentElement';

export class AntimalwareAntiTamperingPanelWebComponent extends BaseFormFieldWebComponentElement<AntimalwareAntiTamperingFormValue> {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AntimalwareAntiTamperingPanelController,
    });
  }
}
